// CUSTOM MODULES
import Styleguide from './modules/Styleguide'
import Tabs from './modules/Tabs'
import Blog from './modules/Blog'
import SubNav from './modules/SubNav'
import Hamburger from './modules/Hamburger'
import Faq from './modules/Faq'

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
    /**
     *  Constructor
     */
    constructor() {
        // document.addEventListener(
        //     'DOMContentLoaded',
        //     function () {
        //         this.onDocumentReady()
        //     }.bind(this)
        // )
        document.addEventListener('DOMContentLoaded', this.init)
    }
    init() {
        new Hamburger()
        Array.from(document.querySelectorAll('.js-tabs')).map((element) => new Tabs(element))
        Array.from(document.querySelectorAll('.js-blog')).map((element) => new Blog(element))
        Array.from(document.querySelectorAll('.js-hasSubmenu')).map(
            (element) => new SubNav(element)
        )
        Array.from(document.querySelectorAll('.js-faq-item')).map((element) => new Faq(element))
    }

    handleStyleguide() {
        new Styleguide()
    }
}

window.app = new App()
